import { createContext, useContext } from 'react';

interface ContextValues {
  openSearch: () => void;
  leftNavDrawerOpen: boolean;
  toggleLeftNavDrawer: (v: boolean) => void;
}

export const PageContext = createContext<ContextValues>({
  openSearch: () => {},
  leftNavDrawerOpen: false,
  toggleLeftNavDrawer: () => null,
});

export const usePageContext = (): ContextValues => useContext(PageContext);
